import { ActionTypes } from 'constants/index'

const initialState = {
    data: null,
    loading: true,
}

const powerBiReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.GET_POWER_BI_REPORT_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload?.data,
                saveSuccess: false,
                updateSuccess: false
            }
        }
        case ActionTypes.GET_POWER_BI_REPORT_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.error
            }
        }
        case ActionTypes.CLEAR_POWER_BI_STATE: {
            return {
                ...state,
                loading: false,
                data: null
            }
        }
        default: {
            return state;
        }
    }
};

export default powerBiReducer;
